import * as React from "react";
import Avatar from "@mui/material/Avatar";
import { createSvgIcon } from "@mui/material/utils";
import { Tooltip } from "@mui/material";

import addIcon from "../../../../../styles/svg/group-plus-icon.svg";
import { useResponsive } from "../../../../../hooks/useResponsive";
import { AddUserDialog } from "./components/AddUserDialog";
import { TooltipName } from "../../../../../utils/Enums";
import { CustomButton } from "../../../../../components/Button/Button";
const emails = ["username@gmail.com", "user02@gmail.com"];

const PlusIcon = createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 4.5v15m7.5-7.5h-15"
    />
  </svg>,
  "Plus"
);

export default function AddUsers({
  boardName,
  users,
  colabratorBoardName,
  isColabrotar,
  handleAddColabrotor,
  assigneeUserId,
  canManageUsers,
  canAddCollaborator,
}) {
  const [open, setOpen] = React.useState(false);
  const [selectedValue, setSelectedValue] = React.useState(emails[1]);
  const isMobile = useResponsive("down", "md");

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = (value) => {
    setOpen(false);
    setSelectedValue(value);
  };

  return (
    <div>
      {(canManageUsers || canAddCollaborator) &&
        (isMobile ? (
          <img src={addIcon} onClick={handleClickOpen} alt="add user" />
        ) : (
          <Tooltip title={isColabrotar ? TooltipName.CARD_DETAIL.ADD_COLABRATOR : TooltipName.BOARD_PAGE.ADD_USER}>
          <CustomButton
          className="reset-btn"
            onClick={handleClickOpen}
            sx={{ padding: 0, minWidth: 0, paddingTop: "2px" }}>
            <Avatar
              className="add-user-avatar">
              <PlusIcon />
            </Avatar>
          </CustomButton>
          </Tooltip>
        ))}

      {open && (
        <AddUserDialog
          boardName={boardName}
          selectedValue={selectedValue}
          open={open}
          onClose={handleClose}
          users={users}
          isColabrotar={isColabrotar}
          colabratorBoardName={colabratorBoardName}
          handleAddColabrotor={handleAddColabrotor}
          setOpen={setOpen}
          assigneeUserId={assigneeUserId}
          isUpdateUser={false}
        />
      )}
    </div>
  );
}
